import { render, staticRenderFns } from "./LargeArticleTeaser.vue?vue&type=template&id=3bb2cdf1&"
import script from "./LargeArticleTeaser.vue?vue&type=script&lang=js&"
export * from "./LargeArticleTeaser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports